// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26BQZ","content":"styles_content__3VBIB","row":"styles_row__Dms85","footer":"styles_footer__fFhtB","phraseLength":"styles_phraseLength__3h_JI"};